import { stdCouleurBleu } from '@commonStyle';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#ffffff',
  },

  header: {
    flexDirection: 'row',
    minHeight: '10%',
    alignItems: 'center',
    paddingTop: 16,
    paddingBottom: 16,
    backgroundColor: '#ffffff',
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    overflow: 'visible',
    zIndex: 100,
  },

  collectiviteTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: stdCouleurBleu,
    flex: 2,
  },

  profileButtonContainer: {
    position: 'relative',
    alignItems: 'flex-end',
    marginLeft: 'auto',
    marginRight: '2%',
    zIndex: 9999,
    gap: 10,
  },

  contentContainer: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#ffffff',
  },

  mainContent: {
    flex: 1,
    padding: 10,
  },
});

export default styles